import Config from '../Config';
import { RestService } from './RestService';

export const RoleService = {
    getRoleList: async function(organisation){
        return RestService.get(`${Config.get_roles}organisation=${organisation}&`, {})
        .then(response => response.json());
    }
};